import image from '@reperio-news/core.components/editorBlocks/Image/index.js';
import imageGallery from '@reperio-news/core.components/editorBlocks/ImageGallery/index.js';
import video from '@reperio-news/core.components/editorBlocks/Video/index.js';

import raw from '@reperio-news/core.components/editorBlocks/Raw/index.js';
import list from '@reperio-news/core.components/editorBlocks/List/index.js';
import embed from '@reperio-news/core.components/editorBlocks/Embed/index.js';
import header from '@reperio-news/core.components/editorBlocks/Header/index.js';
import table from '@reperio-news/core.components/editorBlocks/Table/index.js';

export default {
	header,
	image,
	imageGallery,
	video,
	embed,
	raw,
	list,
	table
}

import * as VideoPlayerDefault from './Video/Default.svelte';
import * as ImageGalleryDefault from '@reperio-news/adh-www-common/src/shared/editorBlocks/ImageGallery/Default.svelte'

export const DOMAIN_VIEWS = {
	video: {default: VideoPlayerDefault},
	imageGallery: {default: ImageGalleryDefault},
}
